import { useMemo, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANG } from "../constants/payment";

/**
 * Custom hook for parsing and managing query parameters
 */
export function useQueryParams() {
  const location = useLocation();
  const [lang, setLang] = useState(DEFAULT_LANG);

  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  // Parse language from query params
  useEffect(() => {
    const langString = queryParams.get("lang") || DEFAULT_LANG;
    setLang(
      SUPPORTED_LANGUAGES.includes(langString) ? langString : DEFAULT_LANG
    );
  }, [queryParams]);

  // Parse orderId from query params
  const orderId = useMemo(() => {
    const q = queryParams.get("q") || "";
    // If your app expects encrypted q, uncomment decrypt logic:
    // if (q?.length > 1) return Utils.decryptAES(q, "1517d362-94fe-11f0-b0b9-0242ac");
    return q;
  }, [queryParams]);

  return { lang, orderId, queryParams };
}